import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Style from './Styles/AddedToCartDialogComponentStyle'
import {
    Link
  } from "react-router-dom";


function SimpleDialog(props) {

  const componentConstants = {
    ...props.componentConstants
  }

  const componentMethods = {
      ...props.componentMethods
  }

  const classes = Style();
  const { onClose } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="addedToCartDialogTitle" open={props.showAddedToCartDialog}>
      <DialogTitle id="addedToCartDialogTitle">{componentConstants.language.LANG_ITEM_ADDED_TO_CART}</DialogTitle>
      <Link to="/checkout" style={classes.link}>
        <Button style={classes.buttonLink} color="secondary" variant="contained">
          {componentConstants.language.LANG_SHOPPING_CART}
        </Button>
      </Link>
      <Button style={classes.button} variant="outlined" color="secondary" onClick={handleClose}>
        {componentConstants.language.LANG_CONTINUE_SHOPPING}
      </Button>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default function SimpleDialogDemo(props) {
    const classes = Style();
  const componentConstants = {
    ...props.componentConstants
  }

  const componentMethods = {
      ...props.componentMethods
  }
  const handleClose = (value) => {
    componentMethods.setManagerState({showAddedToCartDialog: false})
  };
  
  return (
    <div className={classes.root}>
      <SimpleDialog componentConstants={componentConstants} showAddedToCartDialog={componentMethods.getManagerState().showAddedToCartDialog} componentMethods={componentMethods} onClose={handleClose} />
    </div>
  );
}